import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const AuditContextIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return (
    <svg
      style={style}
      className={className}
      id="Layer_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m204.167 419.248c-14.658-14.727-14.658-38.636-.031-53.33 19.011-19.03 47.897-23.722 71.9-11.688 4.085 2.039 8.206 4.096 12.098 6.04v-73.204h-177.801c-19.881-.738-19.866-29.269 0-30h177.801v-17.133c0-6.044 1.156-11.819 3.238-17.134h-181.039c-19.881-.738-19.866-29.269 0-30h273.134c19.881.738 19.866 29.269 0 30h-4.271c2.057 5.281 3.204 11.047 3.204 17.134v49.267h80.333v-83.534c0-25.989-21.145-47.133-47.134-47.133h-64.266c-25.989 0-47.133-21.144-47.133-47.133v-64.283c0-26.065-21.096-47.117-47.117-47.117h-178.883c-26.278 0-47.134 21.325-47.134 47.133v417.733c0 26.279 21.325 47.134 47.134 47.134h224.934c-3.98 0-7.797-1.582-10.61-4.396-.002-.001-59.039-59.079-88.357-88.356zm-93.834-354.981h144.601c19.881.738 19.866 29.269 0 30h-144.601c-19.881-.738-19.866-29.27 0-30zm0 64.266h96.4c19.881.738 19.866 29.269 0 30h-96.4c-19.881-.738-19.866-29.269 0-30zm64.267 222.8h-64.267c-19.881-.738-19.866-29.269 0-30h64.267c19.88.738 19.865 29.269 0 30z" />
        <path d="m334.2 111.4c0 9.447 7.686 17.133 17.133 17.133h64.267c14.589 0 28.244 4.073 39.891 11.14-4.588-10.874-11.273-20.868-19.869-29.464l-83.097-83.097c-8.593-8.594-18.584-15.277-29.454-19.865 7.061 11.642 11.13 25.289 11.13 39.87v64.283z" />
        <path d="m463.8 319.2h-96.4c-8.284 0-15-6.716-15-15v-64.267c-.861-22.784-33.455-22.613-34.267 0v144.6c0 5.198-2.691 10.026-7.114 12.76-4.421 2.731-9.942 2.979-14.594.657-.002-.001-33.811-16.889-33.811-16.889-12.443-6.239-27.398-3.808-37.236 6.039-2.991 3.006-2.991 7.927.019 10.951l83.953 83.949h154.45c9.378 0 17.134-7.562 17.134-17.134v-128.533c0-9.594-7.78-17.133-17.134-17.133z" />
      </g>
    </svg>
  );
};
